<div
  class="w-full border-1 border-round-lg border-gray-400 flex relative {{
    disabled ? 'bg-gray-100' : 'hover:bg-gray-50'
  }}"
  [pTooltip]="disabled ? 'The existing date is on a previous day, so cannot be changed.' : ''"
  tooltipPosition="bottom"
>
  <div
    class="w-1 bg-gray-300 p-1 flex align-items-center justify-content-center border-1 border-round-lg border-round-right-xs border-gray-400"
  >
    <i class="fa fa-calendar"></i>
  </div>
  <div
    #trigger
    class="w-full flex justify-content-between px-2 align-items-center"
    (click)="onTriggerClick($event, op)"
    [ngClass]="{
      'cursor-pointer': !disabled
    }"
  >
    <p class="text-gray-700">{{ scheduleText }}</p>
    <i class="fa fa-chevron-down"></i>
  </div>

  <p-overlayPanel
    #op
    [appendTo]="'body'"
    (onShow)="onOverlayShow()"
    (onHide)="onOverlayHide()"
    [styleClass]="
      'border-1 border-round-lg border-gray-400 bg-white px-3 pt-1 pb-2 calendar shadow-5 my-1'
    "
  >
    <div class="flex justify-content-between align-items-center">
      <h3 class="mt-2 mb-0">{{ title }}</h3>
      <svg
        class="hover:gray-500 cursor-pointer"
        (click)="onCloseClick(op)"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
      >
        <path
          d="M15.5449 13.954C15.7563 14.1653 15.875 14.452 15.875 14.7509C15.875 15.0497 15.7563 15.3364 15.5449 15.5477C15.3336 15.7591 15.0469 15.8778 14.748 15.8778C14.4492 15.8778 14.1625 15.7591 13.9512 15.5477L7.99898 9.59367L2.04492 15.5459C1.83358 15.7572 1.54693 15.8759 1.24805 15.8759C0.949159 15.8759 0.662515 15.7572 0.45117 15.5459C0.239826 15.3345 0.121094 15.0479 0.121094 14.749C0.121094 14.4501 0.239826 14.1635 0.45117 13.9521L6.40523 7.99992L0.453045 2.04586C0.241701 1.83451 0.122969 1.54787 0.122969 1.24898C0.122969 0.950097 0.241701 0.663452 0.453045 0.452108C0.664389 0.240763 0.951034 0.122031 1.24992 0.122031C1.54881 0.122031 1.83545 0.240763 2.0468 0.452108L7.99898 6.40617L13.953 0.45117C14.1644 0.239826 14.451 0.121094 14.7499 0.121094C15.0488 0.121094 15.3355 0.239826 15.5468 0.45117C15.7581 0.662514 15.8769 0.949159 15.8769 1.24804C15.8769 1.54693 15.7581 1.83358 15.5468 2.04492L9.59273 7.99992L15.5449 13.954Z"
          fill="#808080"
        />
      </svg>
    </div>
    <p>Select Date</p>
    <schedule-options-date
      [availableDates]="availableDates?.dateOptions"
      (dateSelected)="handleDateSelected($event)"
      [selectedDate]="selectedDate"
    ></schedule-options-date>

    <div *ngIf="isTimeSelectionVisible()">
      <p>Select Time Window</p>
      <schedule-options-time
        [availableTimeSlots]="getAvailableTimes()"
        (timeSelected)="handleTimeSelected($event)"
        [selectedTime]="selectedTime"
      ></schedule-options-time>
    </div>

    <div
      *ngIf="warningMessage"
      class="my-2 py-3 px-2 bg-orange-50 bg- border-1 border-orange-500 flex justify-content-center align-items-center border-round-lg text-lg"
    >
      <i class="fa fa-warning mr-2" style="color: #f97316"></i>
      <span class=""> {{ warningMessage }}</span>
    </div>

    <div class="flex justify-content-end my-2">
      <button
        pButton
        label="Confirm"
        class="ui-button-primary"
        [disabled]="isSaveScheduleButtonDisabled()"
        (click)="saveSchedule()"
      ></button>
    </div>
  </p-overlayPanel>
</div>
